module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17.449 10.845\"><defs><style>.downarrow{fill:none;stroke:#f3f3f3;stroke-width:3px;}</style></defs><path class=\"downarrow\" d=\"M279.415-4799.184l7.664-7.664,7.664,7.664\" transform=\"translate(295.803 -4798.124) rotate(180)\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./uncommon-client/components/svgs/down-arrow.svg
// module id = 7Vfq
// module chunks = 1